export { load } from './load';
